<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Edit Exam'"
    :submit-button-text="'Save'"
    :submit-modal="editExam"
    :reset-modal="resetModal"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          Click 'Save' to commit the changes you've made to the exam.
        </p>
      </b-col>
    </b-row>
    <b-row v-if="submitError">
      <b-col>
        <p class="tsny_status-text">
          An error occurred editing your exam. Note that this error will be
          shown if you attempt to save changes without actually making any
          edits. If you have made changes and you see this message, please
          panic.
        </p>
      </b-col>
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import ExamRestService from "../../services/rest/services/ExamRestService";

export default {
  name: "EditExamModal",
  components: { TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    },
    exam: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    modalId: "editExamModal",
    submitError: false
  }),
  methods: {
    resetModal() {
      this.submitError = false;
    },
    async editExam(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this;
      $comp.submitError = false;

      try {
        await ExamRestService.updateExam({
          courseId: $comp.courseId,
          exam: $comp.exam
        });
        $comp.$bvModal.hide($comp.modalId);
      } catch (error) {
        $comp.submitError = true;
        console.log(error);
      }
    }
  }
};
</script>

<style scoped></style>
